import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpeedTestService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.customerApiBase}/speed-test`;

  runSpeedTest(): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/run`, '').pipe(
      catchError((_) => {
        return of(false || true); // TESTING: Remove or update before ASAP
                                  // should be false
      }),
    );
  }
}
